import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhimashankarcab() {



    const cardData = {




keyword: "Mumbai to Bhimashankar Cab",

headingDescription: "Shreesha Tours & Travels provides dependable and affordable Mumbai to Bhimashankar cab services for pilgrims, families, tourists, senior citizens, and groups seeking a comfortable journey to one of India's sacred Jyotirlinga temples. We offer one-way cabs, round-trip taxi services, same-day return trips, and customized pilgrimage tour packages with professional drivers and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to suit every travel requirement. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, smooth, and hassle-free travel experience. Whether you are planning a spiritual pilgrimage, family outing, weekend getaway, or nature trip, our Mumbai to Bhimashankar cab service offers punctual drivers, clean vehicles, and personalized travel solutions for a memorable journey through the scenic Western Ghats.",

topPlaces: [
  {
    title: "Bhimashankar Jyotirlinga Temple",
    description: "Bhimashankar Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and is among Maharashtra's most important pilgrimage destinations. Surrounded by lush forests and hills, the temple attracts thousands of devotees throughout the year, especially during Mahashivratri and Shravan. The peaceful spiritual atmosphere and ancient architecture make it a must-visit destination."
  },
  {
    title: "Bhimashankar Wildlife Sanctuary",
    description: "Bhimashankar Wildlife Sanctuary is a protected forest area famous for its rich biodiversity, dense evergreen forests, trekking trails, waterfalls, and the rare Indian Giant Squirrel. Nature lovers, bird watchers, and adventure enthusiasts visit the sanctuary to enjoy its scenic beauty and peaceful environment."
  },
  {
    title: "Hanuman Lake",
    description: "Hanuman Lake is a serene attraction near Bhimashankar surrounded by greenery and hills. It is a peaceful location where visitors can relax, enjoy nature, and spend quality time with family while experiencing the tranquil surroundings of the Western Ghats."
  },
  {
    title: "Gupt Bhimashankar",
    description: "Gupt Bhimashankar is a sacred location believed to be the place where the Bhima River originates. Reached through a scenic forest trail, this hidden spiritual site offers devotees and trekkers a unique combination of natural beauty and religious significance."
  },
  {
    title: "Nagphani Point",
    description: "Nagphani Point, also known as Cobra Point, is one of the highest viewpoints in the Bhimashankar region. It offers breathtaking panoramic views of valleys, forests, and mountain ranges, making it a favorite destination for trekkers, photographers, and nature lovers."
  },
  {
    title: "Ahupe Ghat",
    description: "Ahupe Ghat is a picturesque mountain pass near Bhimashankar known for its mist-covered cliffs, dense forests, waterfalls, and spectacular landscapes. It is especially popular during the monsoon season and offers an unforgettable road trip experience."
  },
  {
    title: "Malshej Ghat",
    description: "Malshej Ghat is one of Maharashtra's most scenic hill destinations, famous for waterfalls, lush green valleys, misty mountains, and beautiful viewpoints. Many travelers include Malshej Ghat while planning an extended trip to Bhimashankar."
  },
  {
    title: "Shivneri Fort",
    description: "Shivneri Fort, the birthplace of Chhatrapati Shivaji Maharaj, is a historically significant hill fort located near Junnar. The fort features ancient gateways, water tanks, temples, and panoramic views, making it a popular destination for history enthusiasts."
  },
  {
    title: "Lenyadri Caves",
    description: "Lenyadri Caves are one of the revered Ashtavinayak Ganpati temples and are carved into a hillside near Junnar. Visitors climb a series of steps to reach the temple while enjoying stunning views of the surrounding landscape and ancient rock-cut architecture."
  },
  {
    title: "Junnar",
    description: "Junnar is a historic town known for ancient caves, forts, temples, vineyards, and rich cultural heritage. It serves as an excellent destination for travelers interested in combining pilgrimage, history, and nature during their Mumbai to Bhimashankar journey."
  }
],



"services": [
  {
    "name": "Mumbai to Bhimashankar Cab",
    "description": "Book Mumbai to Bhimashankar Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for temple visits, family trips, and one way or round trip journeys."
  },
  {
    "name": "Mumbai to Bhimashankar Car Rental",
    "description": "Hire Mumbai to Bhimashankar Car Rental with chauffeur-driven vehicles, affordable pricing, and flexible travel plans for comfortable long-distance journeys."
  },
  {
    "name": "Mumbai to Bhimashankar Taxi",
    "description": "Book Mumbai to Bhimashankar Taxi with experienced drivers, clean AC vehicles, and transparent pricing for a smooth travel experience."
  },
  {
    "name": "Mumbai to Bhimashankar Taxi Cost",
    "description": "Check Mumbai to Bhimashankar Taxi Cost with affordable packages, competitive fares, and quality chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Bhimashankar Taxi Fare",
    "description": "Get Mumbai to Bhimashankar Taxi Fare with transparent pricing, no hidden charges, and flexible one way or round trip options."
  },
  {
    "name": "Taxi Fare from Mumbai to Bhimashankar",
    "description": "Compare Taxi Fare from Mumbai to Bhimashankar with economical pricing and comfortable travel options for families and groups."
  },
  {
    "name": "Mumbai to Bhimashankar Cab",
    "description": "Choose Mumbai to Bhimashankar Cab for reliable intercity transportation with professional chauffeurs and premium vehicles."
  },
  {
    "name": "Mumbai to Bhimashankar Taxi",
    "description": "Reserve Mumbai to Bhimashankar Taxi for safe, convenient, and comfortable temple travel with experienced drivers."
  },
  {
    "name": "Mumbai to Bhimashankar Cab Service",
    "description": "Book Mumbai to Bhimashankar Cab Service with doorstep pickup, affordable fares, and well-maintained AC vehicles."
  },
  {
    "name": "Mumbai to Bhimashankar Taxi Service",
    "description": "Hire Mumbai to Bhimashankar Taxi Service with reliable chauffeurs, flexible booking options, and comfortable vehicles."
  },
  {
    "name": "Mumbai to Bhimashankar One Way Cab",
    "description": "Reserve Mumbai to Bhimashankar One Way Cab for economical travel without return charges and enjoy fixed pricing."
  },
  {
    "name": "Mumbai to Bhimashankar Cab Booking",
    "description": "Complete Mumbai to Bhimashankar Cab Booking online with instant confirmation and multiple vehicle options."
  },
  {
    "name": "Mumbai to Bhimashankar Car Rental",
    "description": "Choose Mumbai to Bhimashankar Car Rental with Sedan, Ertiga, Innova Crysta, and SUV cabs for every travel requirement."
  },
  {
    "name": "Mumbai to Bhimashankar Outstation Cab",
    "description": "Book Mumbai to Bhimashankar Outstation Cab with experienced chauffeurs and comfortable AC vehicles for long-distance travel."
  },
  {
    "name": "Mumbai to Bhimashankar Private Taxi",
    "description": "Hire Mumbai to Bhimashankar Private Taxi for personalized travel with dedicated vehicles and professional drivers."
  },
  {
    "name": "Mumbai Airport to Bhimashankar Cab",
    "description": "Book Mumbai Airport to Bhimashankar Cab with direct airport pickup and reliable chauffeur-driven transportation."
  },
  {
    "name": "Navi Mumbai to Bhimashankar Cab",
    "description": "Reserve Navi Mumbai to Bhimashankar Cab with affordable pricing and comfortable long-distance travel."
  },
  {
    "name": "Thane to Bhimashankar Cab",
    "description": "Choose Thane to Bhimashankar Cab for safe and convenient travel with professional chauffeurs."
  },
  {
    "name": "Panvel to Bhimashankar Taxi",
    "description": "Book Panvel to Bhimashankar Taxi with clean AC vehicles and experienced drivers for comfortable travel."
  },
  {
    "name": "Kalyan to Bhimashankar Cab",
    "description": "Hire Kalyan to Bhimashankar Cab with affordable fares and premium chauffeur-driven vehicles."
  },
  {
    "name": "Dombivli to Bhimashankar Cab",
    "description": "Reserve Dombivli to Bhimashankar Cab with reliable service, flexible schedules, and experienced drivers."
  },
  {
    "name": "Borivali to Bhimashankar Taxi",
    "description": "Book Borivali to Bhimashankar Taxi with convenient pickup, comfortable vehicles, and professional chauffeurs."
  },
  {
    "name": "Andheri to Bhimashankar Cab",
    "description": "Choose Andheri to Bhimashankar Cab with premium vehicles and affordable outstation travel packages."
  },
  {
    "name": "Mumbai International Airport to Bhimashankar Taxi",
    "description": "Book Mumbai International Airport to Bhimashankar Taxi with direct airport transfers and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "T2 Airport Mumbai to Bhimashankar Cab",
    "description": "Reserve T2 Airport Mumbai to Bhimashankar Cab with timely pickup, reliable drivers, and premium travel comfort."
  },
  {
    "name": "Mumbai to Bhimashankar Cab Service",
    "description": "Hire Mumbai to Bhimashankar Cab Service with quality vehicles, experienced chauffeurs, and transparent pricing."
  },
  {
    "name": "Mumbai to Bhimashankar Taxi Service",
    "description": "Choose Mumbai to Bhimashankar Taxi Service for dependable temple travel and comfortable long-distance journeys."
  },
  {
    "name": "One Way Mumbai to Bhimashankar Cab",
    "description": "Book One Way Mumbai to Bhimashankar Cab with fixed fares and economical point-to-point travel."
  },
  {
    "name": "Mumbai Airport to Bhimashankar Cab",
    "description": "Hire Mumbai Airport to Bhimashankar Cab with airport pickup, clean AC vehicles, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Bhimashankar Innova Crysta Cab",
    "description": "Reserve Mumbai to Bhimashankar Innova Crysta Cab for luxury family travel with spacious seating and luggage capacity."
  },
  {
    "name": "Mumbai to Bhimashankar Ertiga Cab",
    "description": "Book Mumbai to Bhimashankar Ertiga Cab for affordable 6 to 7 seater travel with comfortable interiors."
  },
  {
    "name": "Mumbai to Bhimashankar Temple Taxi",
    "description": "Choose Mumbai to Bhimashankar Temple Taxi for comfortable pilgrimage travel with experienced chauffeurs and reliable service."
  },
  {
    "name": "Mumbai to Bhimashankar Jyotirlinga Cab",
    "description": "Book Mumbai to Bhimashankar Jyotirlinga Cab for convenient temple visits with premium vehicles and professional drivers."
  },
  {
    "name": "Best Mumbai to Bhimashankar Cab Booking",
    "description": "Complete Best Mumbai to Bhimashankar Cab Booking with instant confirmation, affordable pricing, and multiple vehicle choices."
  },
  {
    "name": "Mumbai to Bhimashankar Darshan Package",
    "description": "Reserve Mumbai to Bhimashankar Darshan Package with comfortable cab service, flexible schedules, and convenient temple sightseeing."
  }
],
"tableData": [
  ["Mumbai to Bhimashankar Cab", "Mumbai to Bhimashankar Car Rental"],
  ["Mumbai to Bhimashankar Taxi", "Mumbai to Bhimashankar Taxi Cost"],
  ["Mumbai to Bhimashankar Taxi Fare", "Taxi Fare from Mumbai to Bhimashankar"],
  ["Mumbai to Bhimashankar Cab Service", "Mumbai to Bhimashankar Taxi Service"],
  ["Mumbai to Bhimashankar One Way Cab", "Mumbai to Bhimashankar Cab Booking"],
  ["Mumbai to Bhimashankar Outstation Cab", "Mumbai to Bhimashankar Private Taxi"],
  ["Mumbai Airport to Bhimashankar Cab", "Navi Mumbai to Bhimashankar Cab"],
  ["Thane to Bhimashankar Cab", "Panvel to Bhimashankar Taxi"],
  ["Kalyan to Bhimashankar Cab", "Dombivli to Bhimashankar Cab"],
  ["Borivali to Bhimashankar Taxi", "Andheri to Bhimashankar Cab"],
  ["Mumbai International Airport to Bhimashankar Taxi", "T2 Airport Mumbai to Bhimashankar Cab"],
  ["One Way Mumbai to Bhimashankar Cab", "Mumbai to Bhimashankar Innova Crysta Cab"],
  ["Mumbai to Bhimashankar Ertiga Cab", "Mumbai to Bhimashankar Temple Taxi"],
  ["Mumbai to Bhimashankar Jyotirlinga Cab", "Best Mumbai to Bhimashankar Cab Booking"],
  ["Mumbai to Bhimashankar Darshan Package", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Bhimashankar Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels provides comfortable Mumbai to Bhimashankar cab services with professional drivers and well-maintained vehicles, making your pilgrimage or family journey safe and convenient."
  },
  {
    WhyChooseheading: "Perfect for Jyotirlinga Darshan",
    WhyChoosedescription: "Visit the sacred Bhimashankar Jyotirlinga Temple with a private taxi that offers flexible pickup timings, peaceful travel, and convenient door-to-door transportation."
  },
  {
    WhyChooseheading: "Wide Range of Comfortable Vehicles",
    WhyChoosedescription: "Book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, or premium cars according to your group size and travel requirements."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Packages",
    WhyChoosedescription: "Choose from one-way transfers, same-day return cabs, or customized round-trip packages based on your pilgrimage and sightseeing plans."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Ghat Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with the Mumbai to Bhimashankar route and ensure a smooth, safe, and comfortable journey through hilly roads."
  },
  {
    WhyChooseheading: "Customized Pilgrimage & Sightseeing Tours",
    WhyChoosedescription: "You can customize your trip by adding nearby attractions such as Lenyadri Ganpati, Ozar Ganpati Temple, Shivneri Fort, Malshej Ghat, or other destinations on request."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Fleet",
    WhyChoosedescription: "Every vehicle is regularly serviced, air-conditioned, and equipped with comfortable seating to provide a relaxing long-distance travel experience."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking confirmation, and dedicated customer support when reserving your Mumbai to Bhimashankar cab."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Bhimashankar Cab Service?",
    answer: "Yes, we provide Mumbai to Bhimashankar cab services for one-way trips, round trips, pilgrimage tours, and customized travel."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Bhimashankar?",
    answer: "Yes, one-way taxi services are available with pickup from any location in Mumbai."
  },
  {
    question: "Which vehicles are available for Mumbai to Bhimashankar travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a same-day return taxi?",
    answer: "Yes, same-day return and flexible round-trip taxi packages are available according to your travel schedule."
  },
  {
    question: "Is the cab suitable for family pilgrimage trips?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, senior citizens, devotees, and groups visiting Bhimashankar."
  },
  {
    question: "Can I include nearby sightseeing places in my trip?",
    answer: "Yes, you can customize your itinerary to include Lenyadri, Ozar, Shivneri Fort, Malshej Ghat, and other nearby attractions."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and any additional charges depend on the selected package and are explained before booking."
  },
  {
    question: "Is Mumbai to Bhimashankar cab service available every day?",
    answer: "Yes, Shreesha Tours & Travels offers daily cab booking assistance based on advance reservations and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Bhimashankar Cab?",
    answer: "Share your travel date, pickup location, passenger details, preferred vehicle, and trip type to receive a fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Patil",
    feedback: "Our Bhimashankar pilgrimage with Shreesha Tours & Travels was peaceful and comfortable. The driver was courteous, and the vehicle was clean and well maintained.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Deshmukh",
    feedback: "We booked an Ertiga for our family temple visit. The booking process was smooth, the journey was safe, and the overall service exceeded our expectations.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhimashankar Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-bhimashankar-cab.webp",
  "description":
    "Book Mumbai to Bhimashankar Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Bhimashankar with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for Jyotirlinga darshan, pilgrimage tours, family trips, and weekend travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-bhimashankar-cab"
  }
};








    return (
        <div>
<Helmet>
  <title>Mumbai to Bhimashankar Cab | Temple Trip Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Bhimashankar Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable Bhimashankar temple trips with 24x7 online cab booking and transparent taxi fares."
  />

  <meta
    name="keywords"
    content="Mumbai to Bhimashankar Cab, Mumbai to Bhimashankar Car Rental, Mumbai to Bhimashankar Taxi, Mumbai to Bhimashankar Taxi Cost, Mumbai to Bhimashankar Taxi Fare, Taxi Fare from Mumbai to Bhimashankar, Mumbai to Bhimashankar Cab Service, Mumbai to Bhimashankar Taxi Service, Mumbai to Bhimashankar One Way Cab, Mumbai to Bhimashankar Cab Booking, Mumbai to Bhimashankar Car Rental, Mumbai to Bhimashankar Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitobhimashankarcab;